@if (showCopyStatus$ | async) {
  <div
    class="layout--padding-horizontal spacing--padding-half-vertical flex--row flex--nowrap flex--align-center"
  >
    <app-copy-advice-progress class="flex__child--auto"></app-copy-advice-progress>
    <button mat-button (click)="dismissCopyAdviceStatus()">
      {{ 'close' | translate }}
    </button>
  </div>
}
